import { UseQueryOptions, useQuery, useQueries } from "react-query";
import { http } from "./http";
import { PostForMeAccount, PlatformPost, SocialAccountFeedResponse, SocialAccountFeedMeta, PostForMeAccountStatus, SocialPlatform } from "../features/social/post/models";

export type { PostForMeAccount, PlatformPost, SocialAccountFeedResponse, SocialAccountFeedMeta };
export { PostForMeAccountStatus, SocialPlatform };

export function usePostForMeAccounts(ops?: UseQueryOptions<PostForMeAccount[]>) {
  return useQuery<PostForMeAccount[]>({
    queryKey: ["post-for-me-accounts"],
    queryFn: () => http("/api/postforme/accounts"),
    ...ops
  });
}

export function usePostForMeFeeds(accountIds: string[], limit: number = 20, ops?: UseQueryOptions<SocialAccountFeedResponse>) {
  return useQueries(
    accountIds.map(accountId => ({
      queryKey: ["post-for-me-feed", accountId, limit],
      queryFn: () => http(`/api/postforme/accounts/${accountId}/feed?limit=${limit}`) as Promise<SocialAccountFeedResponse>,
      enabled: !!accountId,
      ...ops
    }))
  );
}

export function usePostForMeFeed(accountId: string | null, cursor?: string, limit: number = 20, ops?: UseQueryOptions<SocialAccountFeedResponse>) {
  return useQuery<SocialAccountFeedResponse>({
    queryKey: ["post-for-me-feed", accountId, cursor, limit],
    queryFn: () => http(`/api/postforme/accounts/${accountId}/feed?limit=${limit}${cursor ? `&cursor=${cursor}` : ''}`),
    enabled: !!accountId,
    keepPreviousData: true,
    ...ops
  });
}
